var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0498 13.1995C19.3696 13.2872 18.6854 13.3405 17.9998 13.3594C17.3198 13.3594 16.6398 13.3594 15.9998 13.3594C15.3598 13.3594 14.6398 13.3594 13.9998 13.2994C13.3598 13.2394 12.6398 13.1995 11.9998 13.1395C11.3598 13.0795 10.6398 13.0094 9.99981 12.9794L8.99981 12.9194H7.99981H6.99981H5.99981C5.31981 12.9194 4.63981 12.9194 3.99981 12.9194C3.60981 12.9194 3.29981 12.3495 3.30981 11.5895C3.31981 10.8295 3.62979 10.1995 4.00979 10.1895H4.09978C4.77978 10.3295 5.44978 10.4395 6.09978 10.5195L7.09978 10.6395L8.09978 10.7394L9.09978 10.8195L10.0998 10.8795C10.7798 10.9295 11.4598 10.9395 12.0998 10.9695H14.0998C14.7798 10.9695 15.4598 10.9695 16.0998 10.9695C16.7398 10.9695 17.4598 10.9695 18.0998 10.8995C18.7398 10.8295 19.4598 10.8295 20.0998 10.7595C20.4398 10.7595 20.7198 11.2395 20.7198 11.8995C20.7198 12.5595 20.4598 13.1294 20.1198 13.1694L20.0498 13.1995Z",
    fill: "#173962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.1ffdbb0dc694a6d3d9cd3b76c421f2d2.svg";
export { ForwardRef as ReactComponent };